import { render, staticRenderFns } from "./PaginaAnagraficaUnica.vue?vue&type=template&id=7c6bff94"
import script from "./PaginaAnagraficaUnica.vue?vue&type=script&lang=js"
export * from "./PaginaAnagraficaUnica.vue?vue&type=script&lang=js"
import style0 from "./PaginaAnagraficaUnica.vue?vue&type=style&index=0&id=7c6bff94&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports